/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/orders/order-risk
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import { ShopifyOrderKey, ShopifyOrderRiskKey, ShopifyOrderRiskToOrderKey, ShopifyOrderRiskToShopKey, ShopifyShopKey } from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyOrderRiskKey,
  "2022-01": {
    name: "Shopify Order Risk",
    fields: [
      {
        name: "Cause Cancel",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "cause_cancel" } },
      },
      // {
      //   name: "Checkout",
      //   fieldType: FieldType.BelongsTo,
      //   key: ShopifyOrderRiskToCheckoutKey,
      //   contributorConfiguration:  { [ShopifyDominion.id]: { shopifyFieldKey: "checkout_id" } },
      //   configuration: {
      //     relatedModelKey: ShopifyCheckoutKey,
      //   },
      // },
      {
        name: "Display",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "display" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Merchant Message",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "merchant_message" } },
      },
      {
        name: "Message",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "message" } },
      },
      {
        name: "Order",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderRiskToOrderKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "order_id" } },
        configuration: {
          relatedModelKey: ShopifyOrderKey,
        },
      },
      {
        name: "Recommendation",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "recommendation" } },
      },
      {
        name: "Score",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "score" } },
      },
      {
        name: "Source",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "source" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyOrderRiskToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_sublist", resource: "orderRisk", parent: "order" },
  },
  "2025-04": {
    isDisconnected: true,
    syncConfig: { type: "inherit" } as const, // noop since this is disconnected
  },
};

export const ShopifyOrderRisk = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
